import { request } from "../helpers/utility";

let instance = null;

export default class RotaResources {
    constructor() {
        if (!instance) {
            this.url = 'admin/rota';
            this.user_url = 'user/rota';
            this.rotadatesurl = 'admin/rota/dates';
            this.rotaroles = 'admin/rota-roles';
            instance = this;
        }
        return instance;
    }

    get_rota_detail(date) {
        return request.POST(this.url, {
            event_date: date,
            monthly: false
        })
    }

    get_monthly_rota(date, location_id) {
        return request.POST(this.url, {
            event_date: date,
            location_id: location_id,
            monthly: true
        })
    }

    get_monthly_rota_user(date, location_id) {
        return request.POST(this.user_url, {
            event_date: date,
            location_id: location_id,
            monthly: true
        })
    }

    get_rota_dates() {
        return request.GET(this.rotadatesurl)
    }

    get_rota_roles() {
        return request.GET(this.rotaroles)
    }

    get_event_rotas_admin() {
        return request.GET(this.url + '/events')
    }

    get_event_rotas_user() {
        return request.GET(this.user_url + '/events')
    }

    get_event_rota_admin(event_id) {
        return request.POST(this.url + '/event', {
            event_id: event_id
        })
    }

    get_event_rota_user(event_id) {
        return request.POST(this.user_url + '/event', {
            event_id: event_id
        })
    }

    check_next_month_user(location_id, from_month = null, from_year = null) {
        const params = new URLSearchParams()
        if (location_id) params.set('location_id', location_id)
        if (from_month) params.set('from_month', from_month)
        if (from_year) params.set('from_year', from_year)
        const qs = params.toString()
        return request.GET(this.user_url + '/next-month/check' + (qs ? '?' + qs : ''))
    }

    get_next_month_rota_user(location_id, month, year) {
        const pad = n => String(n).padStart(2, '0')
        const dateStr = `01-${pad(month)}-${year} 00:00:00`
        return request.POST(this.user_url, {
            event_date: dateStr,
            location_id: location_id,
            monthly: true
        })
    }

    update_rota(body) {
        return request.PUT(this.url + '/update', body)
    }

    enable_rota(event_date, location_id) {
        return request.PUT(this.url + '/enable', {
            event_date: event_date,
            location_id: location_id
        })
    }

    enable_event_rota(rota_id) {
        return request.PUT(this.url + '/enable', {
            rota_id: rota_id
        })
    }

    disable_rota(event_date, location_id) {
        return request.PUT(this.url + '/disable', {
            event_date: event_date,
            location_id: location_id
        })
    }

    disable_event_rota(rota_id) {
        return request.PUT(this.url + '/disable', {
            rota_id: rota_id
        })
    }

    create_monthly_rota(body) {
        return request.POST('admin/create_rota', body)
    }

    create_event_rota(body) {
        return request.POST('admin/create_rota', body)
    }


}